import { CheckboxField, SectionHeader } from '@flos/react-ui';
import { useDispatch, useSelector } from 'react-redux';
import { useResourceBundle } from '../contexts/ResourceContext';
import { navigationActions } from '../store/navigation.slice';
import { NavigationState } from '../store/navigation.type';
import { IState } from '../types';
import FormGroup from './common/FormGroup';

const ReviewInsuranceConsent = () => {
  const navigation = useSelector<IState, NavigationState>((state) => state.navigation);
  const dispatch = useDispatch();
  const resource = useResourceBundle();

  const checked =
    navigation.category === 'insurance' || navigation.category === 'others'
      ? navigation.selections[navigation.category].reviewInsurance
      : false;

  const setChecked = (value: boolean) => {
    dispatch(navigationActions.updateReviewConsent(value));
  };

  return (
    <div className="u-Space-up--lg">
      <SectionHeader title={resource['label.review.header']} />

      <FormGroup>
        <div className="Box">
          <div className="Box-content">
            <div className="u-spacing-stack-l">
              <div>{resource['label.review.content']}</div>
            </div>
            <CheckboxField
              label={resource['label.review.consent']}
              name="review"
              value={checked ? 'checked' : undefined}
              onChange={(event) => setChecked(event.target.checked)}
            />
          </div>
        </div>
      </FormGroup>
    </div>
  );
};

export default ReviewInsuranceConsent;
